
document.addEventListener("DOMContentLoaded", function () {
  const state = {
    frequency: "14",
    size: "Small",
    style: null,
    name: "",
    phone: ""
  };

  const dataEl = document.getElementById('subscription-data');
  const subscriptionProduct = JSON.parse(dataEl.dataset.product);
  const discountPercent = parseInt(new URLSearchParams(window.location.search).get('discount')) || 50;

  console.log('Subscription Product:', subscriptionProduct);
  console.log('Discount from URL or default:', discountPercent + '%');

  const styleCards = document.querySelectorAll('.sb-style-card');
  if (styleCards.length > 1) state.style = styleCards[1].dataset.style;
  else if (styleCards.length === 1) state.style = styleCards[0].dataset.style;


  const termsCheckbox = document.getElementById("sb-terms");
  if (termsCheckbox) {
    termsCheckbox.addEventListener("change", function() {
      clearError('sb-terms');
    });
  }

  function activate(el, group) {
    document.querySelectorAll(`.sb-${group} .sb-opt, .sb-${group}-card`).forEach(x => x.classList.remove("active"));
    el.classList.add("active");

    if (group === 'frequency') state.frequency = el.dataset.frequency;
    if (group === 'size') state.size = el.dataset.size;
    if (group === 'style') state.style = el.dataset.style;

    updatePriceDisplay();
    updateStyleCardPrices();
    updateStyleCardImages();
  }

  function updatePriceDisplay() {
    if (!state.frequency || !state.size) return;
    const variant = findVariant(state.size, state.style);
    if (!variant) return;

    const basePrice = variant.price / 100;
    const discountedPrice = basePrice * (1 - discountPercent / 100);
    const priceInfo = document.querySelector('.sb-price-info');

    if (priceInfo) priceInfo.innerHTML = `£${discountedPrice.toFixed(1)}`;
    }

  function updateStyleCardPrices() {
    if (!state.size) return;
    const sizePrices = { Small:25, Medium:39, Large:49, Xl:59 };
    const basePrice = sizePrices[state.size] || 30;
    const discountedPrice = basePrice * (1 - discountPercent / 100);

    document.querySelectorAll('.sb-style-card').forEach(card => {
      const discountedPriceEl = card.querySelector('.discounted-price');
      const originalPriceEl = card.querySelector('.or-price');
      if (discountedPriceEl) {
        const roundedPrice = Number.isInteger(discountedPrice) ? discountedPrice : discountedPrice.toFixed(1);
        discountedPriceEl.textContent = roundedPrice;
      }
      if (originalPriceEl) originalPriceEl.textContent = basePrice.toFixed(0);
    });
  }

  // ---------- Обновлённая функция смены изображений ----------
  function updateStyleCardImages() {
    if (!state.size) return;
    const sizeImageMap = { Small:'imgSmall', Medium:'imgMedium', Large:'imgLarge', Xl:'imgXl' };
    const imageAttribute = sizeImageMap[state.size] || 'imgSmall';

    document.querySelectorAll('.sb-style-card').forEach(card => {
      const img = card.querySelector('.style-image');
      if (!img) return;

      const newImageUrlRaw = card.dataset[imageAttribute];
      if (!newImageUrlRaw) return;

      // Нормализуем URL через new URL() для корректного сравнения
      const currentCleanUrl = img.src ? new URL(img.src, window.location.origin).href : '';
      const newCleanUrl = new URL(newImageUrlRaw, window.location.origin).href;

      if (currentCleanUrl === newCleanUrl) return; // одинаковые — не меняем

      // Предзагрузка изображения
      const tmp = new Image();
      tmp.src = newCleanUrl;
      tmp.onload = function() {
        // Плавное скрытие старого изображения
        img.style.transition = img.style.transition || 'opacity 180ms ease';
        img.style.opacity = '0';
        setTimeout(() => {
          img.src = tmp.src;
          img.onload = function() {
            img.style.opacity = '1';
          };
        }, 50); // небольшой таймаут для плавности
      };
      tmp.onerror = function() {
        console.warn('Image preload failed for', newCleanUrl);
      };
    });
  }
  // ---------- /END обновлённой функции ----------

  function findVariant(size, style) {
    let variant = subscriptionProduct.variants.find(v =>
      v.option1?.toLowerCase().includes(size.toLowerCase()) &&
      v.option2?.toLowerCase().includes(style?.toLowerCase() || '')
    );
    if (!variant) variant = subscriptionProduct.variants.find(v => v.option1?.toLowerCase().includes(size.toLowerCase()));
    if (!variant) variant = subscriptionProduct.variants[0];
    return variant;
  }

  function findSellingPlanByName(frequency) {
    const frequencyMap = {
      '7': ['Every 7 days', 'Every 7', '7 days'],
      '14': ['Every 14 days', 'Every 14', '14 days'],
      '30': ['Monthly Subscription', 'Every 1 Month', 'Monthly']
    };

    const targetNames = frequencyMap[frequency] || [];
    let matchingPlans = [];

    const targetGroupName =
      discountPercent === 50 || discountPercent === 70
        ? "Subscription Landing"
        : "Subscription Page";

    const targetGroup = subscriptionProduct.selling_plan_groups.find(g =>
      g.name.toLowerCase().includes(targetGroupName.toLowerCase())
    );

    if (!targetGroup) {
      console.warn(`⚠️ Не найдена группа "${targetGroupName}", берём первую доступную`);
      return subscriptionProduct.selling_plan_groups[0]?.selling_plans[0] || null;
    }

    for (let plan of targetGroup.selling_plans) {
      if (targetNames.some(name => plan.name.toLowerCase().includes(name.toLowerCase()))) {
        matchingPlans.push(plan);
      }
    }

    if (matchingPlans.length === 0) {
      console.warn(`⚠️ Не найдено планов для ${frequency} дней в группе "${targetGroup.name}"`);
      return targetGroup.selling_plans[0];
    }

    let selectedPlan = null;
    if (discountPercent === 50) {
      selectedPlan = matchingPlans.find(plan => !plan.name.includes("(70)"));
    } else if (discountPercent === 70) {
      selectedPlan = matchingPlans.find(plan => plan.name.includes("(70)"));
    } else {
      selectedPlan = matchingPlans.find(plan =>
        !plan.name.toLowerCase().includes("discount") &&
        !plan.name.includes("(70)")
      );
    }

    if (!selectedPlan) selectedPlan = matchingPlans[0];

    console.log(`✅ Выбран план:`, selectedPlan.name, `из группы "${targetGroup.name}" (discount=${discountPercent}%)`);
    return selectedPlan;
  }

  function showError(inputId, message) {
    const input = document.getElementById(inputId);
    const errorElement = document.getElementById(inputId + '-error');
    if (input) {
      input.classList.add('error');
      if (errorElement) {
        errorElement.textContent = message;
        errorElement.classList.add('show');
      }
    }
  }

  function clearError(inputId) {
    const input = document.getElementById(inputId);
    const errorElement = document.getElementById(inputId + '-error');
    if (input) {
      input.classList.remove('error');
      if (errorElement) errorElement.classList.remove('show');
    }
  }

  function clearAllErrors() {
    clearError('sb-terms');
  }


  function validateFields() {
    let hasErrors = false;
    clearAllErrors();
    if (!document.getElementById("sb-terms").checked) { showError('sb-terms', 'You must agree to the terms and conditions'); hasErrors = true; }

    return !hasErrors;
  }

  async function addToCheckout(variant, sellingPlan) {
    if (!variant?.id || !sellingPlan?.id) return;

    const attributes = {};
    if (discountPercent === 50 || discountPercent === 70) {
      attributes["Discount"] = discountPercent + "%";
    }

    const checkoutBtn = document.getElementById('sb-go-checkout');
    if (checkoutBtn) checkoutBtn.disabled = true;

    const items = [
      { id: variant.id, quantity: 1, selling_plan: sellingPlan.id },
      { id: 53154086125896, quantity: 1 }
    ];
    const svc = window.CartService;

    try {
      // Общая очередь CartService (подключён всегда): сброс корзины (строки
      // в 0 + атрибуты одним update.js, только если в ней что-то есть) → один
      // add.js. Раньше — clear.js, пауза 300 мс, add.js, update.js сырыми fetch.
      await svc.prepareCheckout({
        items: items,
        attributes: Object.keys(attributes).length > 0 ? attributes : undefined,
        clear: 'auto'
      });
    } catch (error) {
      console.error('Subscription constructor: add to cart failed', error);
      if (checkoutBtn) checkoutBtn.disabled = false;
      showError('sb-terms', 'Something went wrong adding your subscription. Please try again.');
      return;
    }

    window.location.href = '/checkout';
  }

  document.querySelectorAll('.sb-frequency .sb-opt').forEach(opt => opt.addEventListener('click', () => activate(opt, 'frequency')));
  document.querySelectorAll('.sb-size .sb-opt').forEach(opt => opt.addEventListener('click', () => activate(opt, 'size')));
  document.querySelectorAll('.sb-style-card').forEach(card => card.addEventListener('click', () => activate(card, 'style')));

  document.getElementById("sb-go-checkout").addEventListener("click", function () {
    if (!validateFields()) return;

    const variant = findVariant(state.size, state.style);
    const sellingPlan = findSellingPlanByName(state.frequency);

    if (!variant || !sellingPlan) {
      alert("Product variant or subscription plan not found");
      return;
    }

    console.log("Selected Selling Plan:", sellingPlan.name, sellingPlan.id);
    addToCheckout(variant, sellingPlan);
  });

  updatePriceDisplay();
  updateStyleCardPrices();
  updateStyleCardImages();
});















